import { number, object, string } from 'yup';
export const validationSchema = object({
  goal: number()
    .required()
    .min(1, 'Goal must be greater than 0')
    .typeError('Goal must be greater than 0'),
});
